import { EntityRepository, Repository } from "typeorm";
import { StockInEntity } from "../stock-in.entity";

@EntityRepository(StockInEntity)
export class StockInRepository extends Repository<StockInEntity>{
}